export default __webpack_public_path__ + "static/media/icon_stripe.80156eda.svg";